import { cn } from 'utils/styling';

const Container = ({ className, $center, ...props }) => {
    return <div className={cn('container', $center ? 'mx-auto' : '', className)} {...props} />;
};

export default Container;
